<template>
  <v-row class="dynamics-indicators-list">
    <v-col
      md="3"
      sm="4"
      cols="12"
      :class="{ 'dynamics-indicator-wrapper_first': inOneRow }"
    >
      <dynamics-indicator-item
        title="Выручка"
        tooltip-text="Выручка за выбранный период"
        icon="/img/stat/icons/cashier.svg"
        value-type="amount"
        :indicator-data="indicators.revenue"
        :loading="loading"
      />
    </v-col>
    <v-col
      md="3"
      sm="4"
      cols="12"
      :class="{ 'dynamics-indicator-wrapper': inOneRow }"
    >
      <dynamics-indicator-item
        title="Заказов"
        tooltip-text="Кол-во заказов в сравнении с прошлым периодом"
        icon="/img/stat/icons/bag.svg"
        value-type="count"
        :indicator-data="indicators.ordersCount"
        :loading="loading"
      />
    </v-col>
    <v-col
      md="3"
      sm="4"
      cols="12"
      :class="{ 'dynamics-indicator-wrapper': inOneRow }"
    >
      <dynamics-indicator-item
        title="Средний чек"
        tooltip-text="Средний чек в сравнении с прошлым периодом"
        icon="/img/stat/icons/receipt.svg"
        value-type="amount"
        :indicator-data="indicators.avgBill"
        :loading="loading"
      />
    </v-col>
    <v-col
      md="3"
      sm="4"
      cols="12"
      :class="{ 'dynamics-indicator-wrapper': inOneRow }"
    >
      <dynamics-indicator-item
        title="Доставка"
        :tooltip-text="deliveryIndicatorTooltipText"
        icon="/img/stat/icons/man.svg"
        value-type="amount"
        :indicator-data="indicators.deliveryRevenue"
        :loading="loading"
      />
    </v-col>
    <v-col
      md="4"
      sm="4"
      cols="12"
      :class="{ 'dynamics-indicator-wrapper': inOneRow }"
    >
      <dynamics-indicator-item
        title="Самовывоз"
        :tooltip-text="pickupIndicatorTooltipText"
        icon="/img/stat/icons/dish.svg"
        value-type="amount"
        :indicator-data="indicators.pickupRevenue"
        :loading="loading"
      />
    </v-col>
    <v-col
      md="4"
      sm="4"
      cols="12"
      :class="{ 'dynamics-indicator-wrapper': inOneRow }"
    >
      <dynamics-indicator-item
        title="Новых клиентов"
        tooltip-text="Новых клиентов за выбранные период в сравнении с прошлым"
        icon="/img/stat/icons/drop.svg"
        value-type="count"
        :indicator-data="indicators.newClientsCount"
        :loading="loading"
      />
    </v-col>
    <v-col
      md="4"
      sm="4"
      cols="12"
      :class="{ 'dynamics-indicator-wrapper': inOneRow }"
    >
      <dynamics-indicator-item
        title="Потеряно клиентов"
        tooltip-text="Клиенты из Клиентской базы, которые перестали делать покупки более 3 месяцев"
        icon="/img/stat/icons/lost-clients.svg"
        value-type="count"
        :indicator-data="indicators.lostClientsCount"
        increasing-status-color="#E92663"
        decreasing-status-color="#6BAD01"
        :loading="loading"
      />
    </v-col>
  </v-row>
</template>

<script>
  import DynamicsIndicatorItem from '@/components/stat/revenue/DynamicsIndicatorItem.vue'

  export default {
    name: 'DynamicsIndicatorsList',
    components: { DynamicsIndicatorItem },
    props: {
      indicators: {
        type: Object,
        default: () => {},
      },
      withoutAggregators: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        windowWidth: window.innerWidth,
      }
    },
    computed: {
      deliveryIndicatorTooltipText () {
        return this.withoutAggregators
          ? 'Выручка доставок без учета агрегаторов'
          : 'Выручка доставок'
      },
      pickupIndicatorTooltipText () {
        return this.withoutAggregators
          ? 'Выручка самовывозов без учета агрегаторов'
          : 'Выручка самовывозов'
      },
      inOneRow () {
        return this.windowWidth >= 1600
      },
    },
    created () {
      window.addEventListener('resize', this.setWindowWidth)
    },
    destroyed () {
      window.removeEventListener('resize', this.setWindowWidth)
    },
    methods: {
      setWindowWidth () {
        this.windowWidth = window.innerWidth
      },
    },
  }
</script>

<style lang="less" scoped>
.dynamics-indicators-list {
  @media (min-width: 1000px) {
    //flex-wrap: nowrap;
  }
}
.dynamics-indicator-wrapper {
  max-width: 14%;

  @media (max-width: 1600px) {
    max-width: revert;
  }

  &_first {
    max-width: 16%;

    @media (max-width: 1600px) {
      max-width: revert;
    }
  }
}
</style>
